$w.onReady(function () {
    $w('#button23').onClick(() => {
        toggleBox($w('#newYorkCollapsibleBox'), $w('#image51'), $w('#image50'));
    });

    $w('#tokyoCollapseButton').onClick(() => {
        toggleBox($w('#tokyoCollapsibleBox'), $w('#tokyoPlusSign'), $w('#tokyoMinusSign'));
    });

    $w('#parisCollapseButton').onClick(() => {
        toggleBox($w('#parisCollapsibleBox'), $w('#parisPlusSign'), $w('#parisMinusSign'));
    });

      $w('#button27').onClick(() => {
        toggleBox($w('#box30'), $w('#image53'), $w('#image52'));
    });

    $w('#button28').onClick(() => {
        toggleBox($w('#box35'), $w('#image55'), $w('#image54'));
    });
});

function toggleBox(boxElement, plusSign, minusSign) {
    const isCollapsed = boxElement.collapsed;
    if (isCollapsed) {
        plusSign.hide();
        minusSign.show();
        boxElement.expand();
    } else {
        minusSign.hide();
        plusSign.show();
        boxElement.collapse();
    }
}